import { __assign, __rest } from "tslib";
import React from 'react';
import { ARROW_LEFT_ICON } from '@marvelapp/theme';
import Button from '../Button';
import Icon from '../Icon';
function BackButton(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Button, __assign({ alignItems: "center", display: "flex", justifyContent: "center", px: 0 }, props),
        React.createElement(Icon, { display: "block", paths: ARROW_LEFT_ICON })));
}
BackButton.defaultProps = {
    borderRadius: 20,
    height: 40,
    kind: 'ghost',
    width: 40,
};
export default BackButton;
